import React from 'react'
import "./admindashboard.css"
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { LiaPenSolid } from "react-icons/lia";
import { MdModeEdit } from "react-icons/md";
import { Cuurent_EMAIL, getEmailClassification } from '../CommonCase/CommonFunctions';


export const handleEdit = (time, id, navigate, timeDifferenceInMinutes) => {
    let diff = parseInt(timeDifferenceInMinutes(time));

    // Keep the same functionality as before
    if (diff >= 15) {
        navigate("/main/meetings/setupmeeting", {
            state: { meetingId: id, flow: "UpcomingMeetings", upcomingMeetingEdit: true },
        });
    } else {
        alert("Cannot edit this meeting");
    }
    navigate("/main/meetings/setupmeeting", { state: { meetingId: id, flow: "UpcomingMeetings", upcomingMeetingEdit: true } })
};


const MeetingsCard = ({ card, rbacRoles }) => {

    const navigate = useNavigate();
    var usermailCurr = Cuurent_EMAIL();

    const { to, from, optional } = getEmailClassification(card?.emailDetail);




    const timeDifferenceInMinutes = (givenTime) => {
        // Create a moment object for the given time
        const givenTimeMoment = moment(givenTime, 'h:mm A');
        // Get the current time as a moment object
        const currentTimeMoment = moment();
        // Calculate the difference in minutes
        const timeDifferenceMinutes = givenTimeMoment.diff(currentTimeMoment, 'minutes');

        return timeDifferenceMinutes;
    }


    return (
        <div className="meeting-card" style={{
            borderTop: (
                card?.deptartmentTagMaster?.deptTag === "Governance" ? "4px solid #057daa" :
                    card?.deptartmentTagMaster?.deptTag === "IT" ? "4px solid #4cb87c" :
                        card?.deptartmentTagMaster?.deptTag === "HR" ? "4px solid #700098" :
                            "4px solid #ff9b00"
            )
        }}
        >

            <div className="meeting-card-icon-container">
                <div
                    id={
                        card?.deptartmentTagMaster?.deptTag == "Facility" ?
                            "facillity" :
                            card?.deptartmentTagMaster?.deptTag == "IT" ?
                                "it" :
                                card?.deptartmentTagMaster?.deptTag == "HR" ?
                                    "hr" :
                                    "governance"
                    }
                    className="meeting-card-icon"
                >
                    <svg id="calendar-checkmark-line-icon" xmlns="http://www.w3.org/2000/svg" width="12.701px" height="15.703" viewBox="0 0 25.701 25.703">
                        <path id="Path_16475" data-name="Path 16475" d="M17.069.989A1.114,1.114,0,0,1,18.276,0a1.114,1.114,0,0,1,1.207.989V5.323a1.114,1.114,0,0,1-1.207.989,1.114,1.114,0,0,1-1.207-.989V.989ZM6.193.989A1.114,1.114,0,0,1,7.4,0,1.114,1.114,0,0,1,8.607.989V5.323A1.114,1.114,0,0,1,7.4,6.312a1.114,1.114,0,0,1-1.207-.989V.989Zm2.38,16.7a.667.667,0,1,1,.924-.962l2.071,2,4.606-4.932a.667.667,0,1,1,.977.91l-5.068,5.43h0l-.008.008a.667.667,0,0,1-.943.019L8.573,17.686ZM1.339,9.479H24.362V4.491a.618.618,0,0,0-.18-.433.61.61,0,0,0-.433-.18H21.543a.669.669,0,1,1,0-1.339H23.75A1.957,1.957,0,0,1,25.7,4.491V23.752A1.957,1.957,0,0,1,23.75,25.7H1.951A1.957,1.957,0,0,1,0,23.75V4.491A1.957,1.957,0,0,1,1.951,2.539H4.309a.669.669,0,1,1,0,1.339H1.951a.618.618,0,0,0-.433.18.61.61,0,0,0-.18.433V9.479ZM24.362,10.82H1.339V23.75a.618.618,0,0,0,.18.433.61.61,0,0,0,.433.18h21.8a.618.618,0,0,0,.433-.18.61.61,0,0,0,.18-.433V10.82ZM10.548,3.878a.669.669,0,0,1,0-1.339h4.495a.669.669,0,0,1,0,1.339Z" fill="#fff" />
                    </svg>

                </div>
            </div>
            <div className="meeting-card-info">
                <div className="meeting-title">
                    <p className="title">{card?.meetingSubject}</p>
                </div>

                <div className="meeting-key-value">
                    <div className="key">
                        <p>Date</p>
                        <span>: </span>
                    </div>
                    <p className='meeting-value'> {moment(card?.parseStartDate, 'DD-MMM-YYYY').format('DD-MMMM-YYYY')}</p>
                </div>
                <div className="meeting-key-value">
                    <div className="key">
                        <p>Time</p>
                        <span>: </span>
                    </div>
                    <p className='meeting-value'>{card?.startTime} - {card?.endTime === "11:59 PM" ? "12:00 AM" : card?.endTime}</p>
                </div>
                <div className="meeting-key-value">
                    <div className="key">
                        <p>Organized By</p>
                        <span>: </span>
                    </div>
                    <p className='meeting-value'>

                        {from[0]?.employeeMaster?.fullName}
                    </p>
                </div>

            </div>
            <div className="meeting-card-btns">
                <button disabled={rbacRoles?.editAccess == "N"} className="meeting-cart-btn-edit" data-testid="meeting-cart-btn-edit"
                    style={{ color: (parseInt(timeDifferenceInMinutes(card?.startTime)) >= 15 && (from[0]?.participantEmail == usermailCurr && rbacRoles?.editAccess)) ? "#00ADEE" : "gray" , cursor: (parseInt(timeDifferenceInMinutes(card?.startTime)) >= 15 && (from[0]?.participantEmail == usermailCurr && rbacRoles?.editAccess)) ? "pointer" : "default" }}
                    onClick={() => {
                        (
                            parseInt(timeDifferenceInMinutes(card?.startTime)) >= 15 &&
                            (from[0]?.participantEmail == usermailCurr && rbacRoles.editAccess)) && handleEdit(card?.startTime, card?.mid, navigate, timeDifferenceInMinutes)
                    }}> <MdModeEdit size={13} /> Edit</button>
                <button className="meeting-cart-btn"  style={{ color:"white", backgroundColor: (parseInt(timeDifferenceInMinutes(card?.startTime)) >= 15 && (from[0]?.participantEmail == usermailCurr && rbacRoles?.editAccess)) ? "#00ADEE" : "gray",cursor: (parseInt(timeDifferenceInMinutes(card?.startTime)) >= 15 && (from[0]?.participantEmail == usermailCurr && rbacRoles?.editAccess)) ? "pointer" : "default" }} >Join</button>
            </div>
            {
                card?.meetingStatus == "Rescheduled" &&
                <div className="reschedult-tag-ongoing">
                    <span>
                        Rescheduled
                    </span>
                </div>
            }
        </div >
    )
}

export default MeetingsCard;